import { useAPICallAsync } from '@michelin/central-provider';
import { useMutation } from 'react-query';
import { rubyOrderRoute as baseRoute } from 'services/restApiConst';
import { OrderResponseType } from 'types/APIResponse';

interface AddPartsParams {
  order: {
    action: { edit: { message: string | null } };
    parts: {
      part_id: string;
      quantity: number;
      dealer_part_id?: string;
      invoice_price?: number;
      final_invoice_price?: number;
    }[];
  };
  perform_now: boolean;
}

export const useAddPartsToOrder = () => {
  const { call } = useAPICallAsync<OrderResponseType, AddPartsParams>({
    api: {
      method: 'PUT',
      endpoint: 'orders',
    },
    baseRoute,
  });

  const mutation = useMutation((params: { payload: AddPartsParams; orderId: number }) => {
    return call(params.payload, params.orderId, true);
  });

  const { isLoading, data, error } = mutation;

  const mutate = async (params: AddPartsParams, orderId: number | string) => {
    const { data: order } = await mutation.mutateAsync({ payload: params, orderId: Number(orderId) });
    return { data: order };
  };

  return {
    ...data,
    loading: isLoading,
    error,
    addParts: mutate,
  };
};
